/**
 * 回到最后组件
 * @author sunzhiguang
 * @date 2020/6/16
 */

import IconFont from "@/components/icon";
import { useTranslation } from "react-i18next";
import React from "react";
import "./index.less";
import downward from "@/assets/images/im/downward.png";

interface IProps {
  onGoEnd?: () => void;
  newMessage?: number;
  text?: string;
}

const GoEnd = (props: IProps) => {
  const { onGoEnd, newMessage = 0, text = "" } = props;
  const { t } = useTranslation("chat");
  return (
    <div
      className="message-back-bottom"
      onClick={() => {
        onGoEnd?.();
      }}
    >
      <IconFont style={{ marginRight: 4, fontSize: "16px" }} type="icondingweijiantou" />
      {/* <img className="jiantou" src={downward} /> */}
      {text ? text : newMessage ? <span>{newMessage}条新消息</span> : t("goEnd")}
    </div>
  );
};

export default GoEnd;
